<template>
  <div class="main-content bg-white">
    <div class="section__content section__content--p30">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12">
            <div class="chart-info">
              <div class="chart-info__left">
                <h3 class="title-4 m-b-15">Welcome to NoisyPeak Services</h3>
                <hr class="line-seprate">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12">
            <div class="row">
              <div class="col-md-4">
                <div class="card link-card" @click.prevent="setProject(1)">
                  <div class="text-sm-center">
                    <img alt="Card image cap" class="img-160" src="/images/cdn_icon.png">
                  </div>
                  <div class="card-body">
                    <h4 class="card-title mb-3">NoisyPeak CDN</h4>
                    <p class="card-text">NoisyPeak CDN is a full service, global CDN
                      and offers you best CDN solution for businesses with advance services
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card link-card" @click.prevent="setProject(2)">
                  <div class="text-sm-center">
                    <img alt="Card image cap" class="img-160" src="/images/encoding_icon.png">
                  </div>
                  <div class="card-body">
                    <h4 class="card-title mb-3">File Transcoding</h4>
                    <p class="card-text">Cloud VOD transcoding. Any format / any container, including HLS, HDS, DASH and HEVC.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card link-card" @click.prevent="setProject(3)">
                  <div class="text-sm-center">
                    <img alt="Card image cap" class="img-160" src="/images/encoding_icon.png">
                  </div>
                  <div class="card-body">
                    <h4 class="card-title mb-3">Live Transcoding</h4>
                    <p class="card-text">Cloud Live transcoding. Any format / any container, including HLS, HDS, DASH and HEVC.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { STORE_TYPES } from '@/store/modules/types';

const projectIndex = {
  1: STORE_TYPES.PROJECT_CODE.CDN,
  2: STORE_TYPES.PROJECT_CODE.FILE_TRANSCODING,
  3: STORE_TYPES.PROJECT_CODE.LIVE_TRANSCODING,
};

const routes = {
  1: 'CDNDashboard',
  2: 'FileTranscodingDashboard',
  3: 'LiveTranscodingDashboard',
};

export default {
  methods: {
    setProject(index) {
      this.$store.dispatch('changeProject', projectIndex[index]);
      this.$router.push({ name: routes[index] });
    },
  },
};
</script>

<style scoped>
.bg-white {
  background-color: #fff !important;
}

.link-card:hover {
  background-color: #edf7ff;
  cursor: pointer;
}
</style>
